import React from 'react';

import {
  Box,
  CircularProgress,
  styled
} from '@mui/material';



const CenteredBox = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  display: 'flex',
  justifyContent: 'center',
  width: '100%'
}));

export interface ILoadingOverlayProps {
  active: boolean;
  darkTheme?: boolean;
}

export const FC: React.FC<ILoadingOverlayProps> = props => {
  return props.active ? (
    <CenteredBox>
      <CircularProgress style={{ color:  props.darkTheme ? '#FFFFFF' : 'inherit' }}/>
    </CenteredBox>
  ) : null;
};
